<template>
    <!-- 상품 카테고리 -->
    <div :class="`category-sidebar-container${show ? '' : ' sidebar-hide'}`">
        <div class="category-sidebar-wrapper">
            <!-- 업체페이지용 정보 -->
            <shop-brand-card v-if="store" :store="store"></shop-brand-card>
            <!-- 카테고리 네비게이션 -->
            <nav class="product-category-container">
                <button :aria-pressed="JSON.stringify(show)" class="toggle" @click="show = !show"><span class="blind">카테고리 사이드바 토글</span></button>
                <div class="product-category-wrapper">
                    <ul class="product-category-titles">
                        <li>
                            <router-link tag="a" :to="rootPath" class="product-category-title">전체보기</router-link>
                        </li>
                        <li v-for="item in items" :key="item._id">
                            <!-- 선택된 카테고리 -->
                            <template v-if="_selecteds.includes(item._id)">
                                <router-link tag="a" :to="`${rootPath}/${item._id}`" class="product-category-title" :exact-active-class="_selecteds.includes(item._id) ? 'on' : 'off'">{{ item.name }}</router-link>
                                <ul v-if="(filter(item.children) || []).length" class="product-category">
                                    <category-expander :_selecteds="_selecteds" v-for="child in filter(item.children)" :key="child._id" :category="child" :to="`${rootPath}/${child._id}`">
                                        <category-expander :_selecteds="_selecteds" v-for="grandChild in filter(child.children)" :key="grandChild._id" :category="grandChild" :to="`${rootPath}/${grandChild._id}`">
                                            <category-expander :_selecteds="_selecteds" v-for="granderChild in filter(grandChild.children)" :key="granderChild._id" :category="granderChild" :to="`${rootPath}/${granderChild._id}`"> </category-expander>
                                        </category-expander>
                                    </category-expander>
                                </ul>
                            </template>
                            <!-- 선택되지 않은 카테고리 -->
                            <template v-else>
                                <router-link tag="a" :to="`${rootPath}/${item._id}`" class="product-category-title">{{ item.name }}</router-link>
                            </template>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import CategoryExpander from "@/components/client/shop/category-expander.vue";
import ShopBrandCard from "@/components/client/shop/shop-brand-card.vue";

import { mapActions, mapState } from "vuex";
export default {
    components: {
        CategoryExpander,
        ShopBrandCard,
    },
    props: {
        store: { type: Object, default: null },
        _category: String,
    },
    data() {
        return {
            show: true,
            JSON,
        };
    },
    computed: {
        ...mapState({ categories: (state) => state?.shop?.categories }),
        categories_children() {
            return this.categories.flatMap(({ children }) => children);
        },
        categories_grandChildren() {
            return this.categories_children.flatMap(({ children }) => children);
        },
        categories_granderChildren() {
            return this.categories_grandChildren.flatMap(({ children }) => children);
        },
        category() {
            return this.getCategory(this.categories) ?? this.getCategory(this.categories_children) ?? this.getCategory(this.categories_grandChildren) ?? this.getCategory(this.categories_granderChildren);
        },
        items() {
            return this.filter(this.categories);
        },
        _selecteds() {
            const { depth } = this.category || {};
            switch (depth) {
                case 1:
                    return [this._category];
                case 2:
                    return [this._category, ...this.category._parents];
                case 3:
                    return [this._category, ...this.category._parents, this.categories.filter(({ _children }) => _children.some((_child) => this.category._parents.includes(_child)))];
                case 4:
                    const _categoriesChildren = this.categories_children.filter(({ _children }) => _children.some((_child) => this.category._parents.includes(_child)));
                    return [this._category, ...this.category._parents, ..._categoriesChildren, ...this.categories.filter(({ _children }) => _children.some((_child) => _categoriesChildren.includes(_child)))];
                default:
                    return [this._category];
            }
        },

        rootPath() {
            if (this.store) return `/shop/store/${this.store._id}`;
            return `/shop/categories`;
        },
    },
    created() {
        this.init();
    },
    methods: {
        ...mapActions("shop", ["getCategories"]),
        async init() {
            try {
                await this.getCategories();
            } catch (error) {
                console.error(error);
            }
        },

        filter(categories) {
            if (!this.store) return categories;

            const _categories = this.store.products.map((product) => product._category);
            return this.categories.filter((category) => _categories.includes(category._id));
        },

        getCategory(categories) {
            return categories.find(({ _id }) => _id == this._category);
        },
    },
};
</script>

<style lang="scss">
$color-primary: #ffb81d;
$arrow-default: #555555;
$arrow-grey: #d1d1d1;

[data-category-sidebar="opened"] {
    .product-lists {
        margin-left: 0;
        margin-right: 0;
    }
}
[data-category-sidebar="closed"] {
    .product-category-container {
        padding: 0;
    }
    .category-sidebar-wrapper {
        width: 0;
        border-right: none;
    }
    .product-category-wrapper {
        display: none;
    }
}
@media (min-width: 1281px) and (max-width: 1920px) {
    [data-category-sidebar="opened"] {
        .product-lists {
            margin-left: 345px;
        }
        .product-lists__inner {
            margin: 0;
        }
    }
}

.category-sidebar-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index:99;
    background-color:#fff;
    transition: 0.3s ease-in-out;
    &.sidebar-hide {
        transform: translateX(-100%);
    }
}
.category-sidebar-wrapper {
    position: relative;
    width: 300px;
    min-height: 650px;
    height: 100%;
    border-right: 1px solid #eeeeee;
}

// 카테고리
.product-category {
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 20px;
    list-style: none;
    border-bottom: 1px solid #e9e9e9;
    &-container {
        position: absolute;
        padding: 60px 40px;
        width: inherit;
        .toggle {
            z-index: 2;
            position: absolute;
            top: 0;
            right: -20px;
            width: 20px;
            height: 40px;
            background-color: $color-primary;
        }
        .toggle::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 8px;
            height: 14px;
            background-image: url("/images/icon/product-fillters-toggle-arrow.png");
        }
        .toggle[aria-pressed="false"]::before {
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
        }
    }
    &-titles {
        list-style: none;
    }
    &-title {
        display: block;
        margin-bottom: 20px;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
    }
    [data-toggle="opened"] + &__expand,
    &__expand.on {
        transform: rotate(180deg);
    }
    .expanded {
        max-height: none;
    }
    &__header {
        display: flex;
        padding-bottom: 12px;
    }
    &__expand {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        color: $arrow-default;
        transition: all ease 0.1s;
    }
    &__expand svg {
        display: block;
        width: 11px;
        height: 7px;
        pointer-events: none;
    }
    &__link {
        flex: 1 0 auto;
        display: block;
        position: relative;
        font-size: 16px;
        font-weight: 300;
        cursor: pointer;
        user-select: none;
    }
    &__sub {
        overflow: hidden;
        transition: all ease 0.2s;
    }
    &__level {
        margin-left: 10px;
        list-style: none;
    }
    &__level--2 a {
        display: block;
        line-height: 1;
        font-size: 16px;
        color: #777777;
        font-weight: 300;
        cursor: pointer;
        user-select: none;
    }
    &__level-link {
        display: block;
        position: relative;
        padding: 6px 0;
        line-height: 1;
        font-size: 16px;
        color: #777777;
        font-weight: 300;
        cursor: pointer;
        user-select: none;
    }
    &__level-link[data-toggle] &__expand {
        color: $arrow-grey;
    }
    &__level-link[data-toggle="opened"] + .product-category__level {
        display: block;
    }
    &-title.on,
    &__link.on,
    &__level--2 a.on,
    &__level-link.on {
        color: $color-primary;
        font-weight: 500;
    }
}
@media (min-width: 1025px) {
    a.product-category-title:hover {
        opacity: 0.75;
    }
}
@media (max-width: 1024px) {
    .category-sidebar-container {
        display: none;
    }
}
</style>
